<template>
    <b-modal :active.sync="isComponentModalActive"
             has-modal-card full-screen  >
        <div class="modal-card">
            <header class="modal-card-head">
            <p class="has-text-info  is-size-5 "> {{ headerCustomize }} </p>
            </header>
            <section class="modal-card-body">
                <!-- Content ... -->

               
                <b-tabs  type="is-box" v-model="mainTab" expanded @input="mainTabChange">
                    <b-tab-item label="Customize No.1" icon="numeric-1-box-outline"    >
                    <b-button type="is-success"  icon-left="content-save"  @click="saveData"  :loading="isSaveLoading"  >Save Customize No 1</b-button>
                    <br>
                    <strong class="has-text-danger">Example</strong>
                    <b-table bordered :data="dataRaw" :columns="columnsCUS1" class="is-success" ></b-table>
                    <hr>
                    <div class="columns ">
                        <div class="column">
                            <b-tabs  type="is-boxed" >
                                <b-tab-item label="HEMATOLOGY">
                                   
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for="dataLabParamMasterChunkHematoCUS1 in dataLabParamsMasterChunkHematoCUS1" :key="dataLabParamMasterChunkHematoCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkHematoCUS1 " :key="datCUS1.id">
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>
                                <b-tab-item label="BODY FLUID">
                                   
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for="dataLabParamMasterChunkBodyfluidCUS1 in dataLabParamsMasterChunkBodyfluidCUS1" :key="dataLabParamMasterChunkBodyfluidCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkBodyfluidCUS1 " :key="datCUS1.id">
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>
                                <b-tab-item label="BLOOD CHEM.">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for="dataLabParamMasterChunkBlChemCUS1 in dataLabParamsMasterChunkBlChemCUS1"  :key="dataLabParamMasterChunkBlChemCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkBlChemCUS1 "  :key="datCUS1.id" >
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>

                                <b-tab-item label="Hormone">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for="dataLabParamMasterChunkHormoneCUS1 in dataLabParamsMasterChunkHormoneCUS1"  :key="dataLabParamMasterChunkHormoneCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkHormoneCUS1 "  :key="datCUS1.id" >
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>

                               <b-tab-item label="Blood Gas">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for="dataLabParamMasterChunkBloodGasCUS1 in dataLabParamsMasterChunkBloodGasCUS1"  :key="dataLabParamMasterChunkBloodGasCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkBloodGasCUS1 "  :key="datCUS1.id" >
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>  


                                <b-tab-item  label="BLOOD PARASITE">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for=" dataLabParamMasterChunkBlParasiteCUS1 in  dataLabParamsMasterChunkBlParasiteCUS1" :key="dataLabParamMasterChunkBlParasiteCUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkBlParasiteCUS1"  :key="datCUS1.id">
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>
                                <b-tab-item  label="UA">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                            <th> </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <template   >

                                            <tr v-for=" dataLabParamMasterChunkUACUS1 in  dataLabParamsMasterChunkUACUS1" :key="dataLabParamMasterChunkUACUS1.id" >
                                                <td v-for="datCUS1 in dataLabParamMasterChunkUACUS1" :key="datCUS1.id">
                                                    <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                    <b-switch type="is-success"  v-model="datCUS1.isSwitchedCUS1" >{{ datCUS1.label }}</b-switch>
                                                </td>
                                            </tr>


                                        </template>


                                        </tbody>
                                    </table>
                                </b-tab-item>
                            </b-tabs>
                        </div>
                        <div class="column">
                            <div class="box">
                                <b-table
                                        :data="dataLabSelectedByUserCUS1"
                                        draggable
                                        @dragstart="dragstartCUS1"
                                        @drop="dropCUS1"
                                        @dragover="dragoverCUS1"
                                        @dragleave="dragleaveCUS1"

                                >


                                        <b-table-column field="label" label="PARAMS SELECTED"   v-slot="props">
                                            {{ props.row.label }}
                                        </b-table-column>

                                        <b-table-column field="group" label="CATEGORY"  :visible="true" v-slot="props">
                                            {{ props.row.group }}
                                        </b-table-column>


                                        <b-table-column field="key" label="KEY"  :visible="false" v-slot="props">
                                            {{ props.row.key }}
                                        </b-table-column>

                                        <b-table-column field="uuid" label="UUID"  :visible="false" v-slot="props">
                                            {{ props.row.uuid }}
                                        </b-table-column>

                                        <b-table-column field="order" label="ORDER"  :visible="false" v-slot="props">
                                            {{ props.row.order }}
                                        </b-table-column>




                                </b-table>
                            </div>
                        </div>
                    </div>
                    </b-tab-item>
                    <b-tab-item label="Customize No.2" icon="numeric-2-box-outline" >
                        <b-button type="is-success"  icon-left="content-save"  @click="saveData"  :loading="isSaveLoading"  >Save Customize No 2</b-button>
                        <br>
                        <strong class="has-text-danger">Example</strong>
                        <b-table bordered :data="dataRaw" :columns="columnsCUS2" class="is-success" ></b-table>
                        <hr>
                        <div class="columns ">
                            <div class="column">
                                <b-tabs  type="is-boxed" >
                                    <b-tab-item label="HEMATOLOGY">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for="dataLabParamMasterChunkHematoCUS2 in dataLabParamsMasterChunkHematoCUS2" :key="dataLabParamMasterChunkHematoCUS2.id" >
                                                    <td v-for="datCUS2 in dataLabParamMasterChunkHematoCUS2 " :key="datCUS2.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS2.isSwitchedCUS2" >{{ datCUS2.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item label="BLOOD CHEM.">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for="dataLabParamMasterChunkBlChemCUS2 in dataLabParamsMasterChunkBlChemCUS2"  :key="dataLabParamMasterChunkBlChemCUS2.id" >
                                                    <td v-for="datCUS2 in dataLabParamMasterChunkBlChemCUS2 "  :key="datCUS2.id" >
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS2.isSwitchedCUS2" >{{ datCUS2.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item  label="BLOOD PARASITE">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for=" dataLabParamMasterChunkBlParasiteCUS2 in  dataLabParamsMasterChunkBlParasiteCUS2" :key="dataLabParamMasterChunkBlParasiteCUS2.id" >
                                                    <td v-for="datCUS2 in dataLabParamMasterChunkBlParasiteCUS2"  :key="datCUS2.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS2.isSwitchedCUS2" >{{ datCUS2.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item  label="UA">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for=" dataLabParamMasterChunkUACUS2 in  dataLabParamsMasterChunkUACUS2" :key="dataLabParamMasterChunkUACUS2.id" >
                                                    <td v-for="datCUS2 in dataLabParamMasterChunkUACUS2" :key="datCUS2.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS2.isSwitchedCUS2" >{{ datCUS2.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                </b-tabs>
                            </div>
                            <div class="column">
                                <div class="box">
                                    <b-table
                                            :data="dataLabSelectedByUserCUS2"
                                            draggable
                                            @dragstart="dragstartCUS2"
                                            @drop="dropCUS2"
                                            @dragover="dragoverCUS2"
                                            @dragleave="dragleaveCUS2"

                                    >


                                            <b-table-column field="label" label="PARAMS SELECTED"   v-slot="props">
                                                {{ props.row.label }}
                                            </b-table-column>

                                            <b-table-column field="group" label="CATEGORY"  :visible="true" v-slot="props">
                                                {{ props.row.group }}
                                            </b-table-column>


                                            <b-table-column field="key" label="KEY"  :visible="false" v-slot="props">
                                                {{ props.row.key }}
                                            </b-table-column>

                                            <b-table-column field="uuid" label="UUID"  :visible="false" v-slot="props">
                                                {{ props.row.uuid }}
                                            </b-table-column>

                                            <b-table-column field="order" label="ORDER"  :visible="false" v-slot="props">
                                                {{ props.row.order }}
                                            </b-table-column>




                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </b-tab-item>
                    <b-tab-item label="Customize No.3" icon="numeric-3-box-outline" >
                        <b-button type="is-success"  icon-left="content-save"  @click="saveData"  :loading="isSaveLoading"  >Save Customize No 3</b-button>
                        <br>
                        <strong class="has-text-danger">Example</strong>
                        <b-table bordered :data="dataRaw" :columns="columnsCUS3" class="is-success" ></b-table>
                        <hr>
                        <div class="columns ">
                            <div class="column">
                                <b-tabs  type="is-boxed" >
                                    <b-tab-item label="HEMATOLOGY">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for="dataLabParamMasterChunkHematoCUS3 in dataLabParamsMasterChunkHematoCUS3" :key="dataLabParamMasterChunkHematoCUS3.id" >
                                                    <td v-for="datCUS3 in dataLabParamMasterChunkHematoCUS3 " :key="datCUS3.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS3.isSwitchedCUS3" >{{ datCUS3.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item label="BLOOD CHEM.">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for="dataLabParamMasterChunkBlChemCUS3 in dataLabParamsMasterChunkBlChemCUS3"  :key="dataLabParamMasterChunkBlChemCUS3.id" >
                                                    <td v-for="datCUS3 in dataLabParamMasterChunkBlChemCUS3 "  :key="datCUS3.id" >
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS3.isSwitchedCUS3" >{{ datCUS3.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item  label="BLOOD PARASITE">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for=" dataLabParamMasterChunkBlParasiteCUS3 in  dataLabParamsMasterChunkBlParasiteCUS3" :key="dataLabParamMasterChunkBlParasiteCUS3.id" >
                                                    <td v-for="datCUS3 in dataLabParamMasterChunkBlParasiteCUS3"  :key="datCUS3.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS3.isSwitchedCUS3" >{{ datCUS3.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                    <b-tab-item  label="UA">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <template   >

                                                <tr v-for=" dataLabParamMasterChunkUACUS3 in  dataLabParamsMasterChunkUACUS3" :key="dataLabParamMasterChunkUACUS3.id" >
                                                    <td v-for="datCUS3 in dataLabParamMasterChunkUACUS3" :key="datCUS3.id">
                                                        <!--                                                <b-switch type="is-success"  v-model="dataLabParamMaster.isSwitched" >{{ dataLabParamMaster.label }}</b-switch>-->
                                                        <b-switch type="is-success"  v-model="datCUS3.isSwitchedCUS3" >{{ datCUS3.label }}</b-switch>
                                                    </td>
                                                </tr>


                                            </template>


                                            </tbody>
                                        </table>
                                    </b-tab-item>
                                </b-tabs>
                            </div>
                            <div class="column">
                                <div class="box">
                                    <b-table
                                            :data="dataLabSelectedByUserCUS3"
                                            draggable
                                            @dragstart="dragstartCUS3"
                                            @drop="dropCUS3"
                                            @dragover="dragoverCUS3"
                                            @dragleave="dragleaveCUS3"

                                    >


                                            <b-table-column field="label" label="PARAMS SELECTED"   v-slot="props">
                                                {{ props.row.label }}
                                            </b-table-column>

                                            <b-table-column field="group" label="CATEGORY"  :visible="true" v-slot="props">
                                                {{ props.row.group }}
                                            </b-table-column>


                                            <b-table-column field="key" label="KEY"  :visible="false" v-slot="props">
                                                {{ props.row.key }}
                                            </b-table-column>

                                            <b-table-column field="uuid" label="UUID"  :visible="false" v-slot="props">
                                                {{ props.row.uuid }}
                                            </b-table-column>

                                            <b-table-column field="order" label="ORDER"  :visible="false" v-slot="props">
                                                {{ props.row.order }}
                                            </b-table-column>




                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </b-tab-item>
                </b-tabs>


            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger"
                          icon-left="close"  @click="closeModal"   >
                    Close
                </b-button>
            </footer>
        </div>
    </b-modal>


</template>

<script>
    /* eslint-disable no-console */
    import _ from 'lodash'
    import {mapState , mapActions} from 'vuex'
    import axios from "axios";
    import {   getBaseURLforBackEnd  , getConfigAxios  , genUUID } from '@/utils.js'


    export default {
        name: "DlgManageCBCCustomize",
        computed: {
            ...mapState({
                user_id : state => state.master_data.user_id ,
                userCustomizeCBCTbl : state => state.master_data.userCustomizeCBCTbl,
                dataLabParamsMaster : state => state.master_data.dataLabParamsMaster,
            }) ,
            //****************************************
            //******   CUS 1
            //****************************************
            dataLabParamsMasterChunkHematoCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'HEMATOLOGY' })

                return _.chunk(Object.values(dat), 4);
            },
            dataLabParamsMasterChunkBodyfluidCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BODY_FLUID' })

                return _.chunk(Object.values(dat), 4);
            },
            dataLabParamsMasterChunkBlChemCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD_CHEMISTRY' })

                return _.chunk(Object.values(dat), 4);
            } ,

            dataLabParamsMasterChunkHormoneCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'HORMONE' })

                return _.chunk(Object.values(dat), 4);
            } ,
            
            dataLabParamsMasterChunkBloodGasCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD_GAS' })

                return _.chunk(Object.values(dat), 4);
            } ,
            
            dataLabParamsMasterChunkBlParasiteCUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD PARASITE' })

                return _.chunk(Object.values(dat), 4);
            } ,
            dataLabParamsMasterChunkUACUS1(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'UA' })

                return _.chunk(Object.values(dat), 4);
            } ,
            //****************************************
            //******   CUS 2
            //****************************************
            dataLabParamsMasterChunkHematoCUS2(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'HEMATOLOGY' })

                return _.chunk(Object.values(dat), 4);
            },
            dataLabParamsMasterChunkBlChemCUS2(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD CHEMISTRY' })

                return _.chunk(Object.values(dat), 4);
            } ,
            dataLabParamsMasterChunkBlParasiteCUS2(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD PARASITE' })

                return _.chunk(Object.values(dat), 4);
            } ,
            dataLabParamsMasterChunkUACUS2(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'UA' })

                return _.chunk(Object.values(dat), 4);
            } ,
            //****************************************
            //******   CUS 3
            //****************************************
            dataLabParamsMasterChunkHematoCUS3(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'HEMATOLOGY' })

                return _.chunk(Object.values(dat), 4);
            },
            dataLabParamsMasterChunkBlChemCUS3(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD CHEMISTRY' })

                return _.chunk(Object.values(dat), 4);
            } ,
            dataLabParamsMasterChunkBlParasiteCUS3(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'BLOOD PARASITE' })

                return _.chunk(Object.values(dat), 4);
            } ,
            dataLabParamsMasterChunkUACUS3(){
                const dat = _.reject(this.dataLabParamsMaster, function(o) { return o.group !== 'UA' })

                return _.chunk(Object.values(dat), 4);
            } ,
        },
        watch :{
            dataLabParamsMaster : {
                handler: function (dataLabParamsMasterNewVal) {
                    // find loop for check "isSwitched"
                    // find in dataLabSelectedByUser exists "key" or not
                    // if not ==> push it
                    // if exist && "isSwitched" === false  ==>  remove it
                    var found = false
                    var i=0
                    var j=0
                    for( i=0 ; i <dataLabParamsMasterNewVal.length ; i++){
                        // CUS1
                        found = false
                        for ( j =0 ; j < this.dataLabSelectedByUserCUS1.length; j++){
                            if (this.dataLabSelectedByUserCUS1[j]['key'] === dataLabParamsMasterNewVal[i]['key']){
                                found = true
                                if(!dataLabParamsMasterNewVal[i]['isSwitchedCUS1'])  {
                                    this.dataLabSelectedByUserCUS1.splice(j,1)
                                    break
                                }
                            }
                        }

                        if(!found){
                            if(dataLabParamsMasterNewVal[i]['isSwitchedCUS1'])  {
                                //  {  "uuid" : "dfgsfgsdfgsdfg" , "label"  : "HGB",  "order" : 1 ,"key" : "hm_hgb" ,"group" : "HEMATO"},
                                const tmpPush =  {  "uuid" : genUUID(10) , "label"  :dataLabParamsMasterNewVal[i]['label'] ,  "order" : 0 ,"key" : dataLabParamsMasterNewVal[i]['key'] ,"group" : dataLabParamsMasterNewVal[i]['group']}
                                this.dataLabSelectedByUserCUS1.push(tmpPush)
                                // this.dataLabSelectedByUserCUS1.unshift(tmpPush)
                            }

                        }
                        //******************************
                        // CUS2
                        //******************************
                        found = false
                        for (j =0 ; j < this.dataLabSelectedByUserCUS2.length; j++){
                            if (this.dataLabSelectedByUserCUS2[j]['key'] === dataLabParamsMasterNewVal[i]['key']){
                                found = true
                                if(!dataLabParamsMasterNewVal[i]['isSwitchedCUS2'])  {
                                    this.dataLabSelectedByUserCUS2.splice(j,1)
                                    break
                                }
                            }
                        }

                        if(!found){
                            if(dataLabParamsMasterNewVal[i]['isSwitchedCUS2'])  {
                                const tmpPush =  {  "uuid" : genUUID(10) , "label"  :dataLabParamsMasterNewVal[i]['label'] ,  "order" : 0 ,"key" : dataLabParamsMasterNewVal[i]['key'] ,"group" : dataLabParamsMasterNewVal[i]['group']}
                                this.dataLabSelectedByUserCUS2.push(tmpPush)
                                // this.dataLabSelectedByUserCUS2.unshift(tmpPush)
                            }

                        }

                        //******************************
                        // CUS3
                        //******************************
                        found = false
                        for (j =0 ; j < this.dataLabSelectedByUserCUS3.length; j++){
                            if (this.dataLabSelectedByUserCUS3[j]['key'] === dataLabParamsMasterNewVal[i]['key']){
                                found = true
                                if(!dataLabParamsMasterNewVal[i]['isSwitchedCUS3'])  {
                                    this.dataLabSelectedByUserCUS3.splice(j,1)
                                    break
                                }
                            }
                        }

                        if(!found){
                            if(dataLabParamsMasterNewVal[i]['isSwitchedCUS3'])  {
                                const tmpPush =  {  "uuid" : genUUID(10) , "label"  :dataLabParamsMasterNewVal[i]['label'] ,  "order" : 0 ,"key" : dataLabParamsMasterNewVal[i]['key'] ,"group" : dataLabParamsMasterNewVal[i]['group']}
                                this.dataLabSelectedByUserCUS3.push(tmpPush)
                                // this.dataLabSelectedByUserCUS3.unshift(tmpPush)
                            }

                        }


                    }
                },
                deep: true
            } ,
            dataLabSelectedByUserCUS1 : {
                handler: function () {
                    this.makeColumn(this.dataLabSelectedByUserCUS1,this.columnsCUS1)
                },
                deep: true
            } ,
            dataLabSelectedByUserCUS2 : {
                handler: function () {
                    this.makeColumn(this.dataLabSelectedByUserCUS2,this.columnsCUS2)
                },
                deep: true
            } ,

            dataLabSelectedByUserCUS3 : {
                handler: function () {
                    this.makeColumn(this.dataLabSelectedByUserCUS3,this.columnsCUS3)
                },
                deep: true
            } ,

            isComponentModalActive :{
                handler: function () {
                    if(this.isComponentModalActive){
                        // clear dataLabSelectedByUserCUS
                        this.dataLabSelectedByUserCUS1 = []
                        this.dataLabSelectedByUserCUS2 = []
                        this.dataLabSelectedByUserCUS3 = []
                        // read data from state
                        // fill into dataLabParamsMaster
                        // and push data into dataLabSelectedByUserCUS...N
                        var i = 0
                        // CUS1
                        for(i = 0 ; i < this.userCustomizeCBCTbl.cus1.length;i++ ){
                            const keyCus = this.userCustomizeCBCTbl.cus1[i]
                            const memberLABParam = this.dataLabParamsMaster.find( member => member.key === keyCus.key)
                            const memberLABParamIndex = this.dataLabParamsMaster.indexOf(memberLABParam)
                            this.dataLabParamsMaster[memberLABParamIndex].isSwitchedCUS1 = true


                            // this.dataLabSelectedByUserCUS1.push(this.userCustomizeCBCTbl.cus1[i])
                            this.dataLabSelectedByUserCUS1.unshift(this.userCustomizeCBCTbl.cus1[i])
                        }
                        // CUS2
                        for(i = 0 ; i < this.userCustomizeCBCTbl.cus2.length;i++ ){
                            const keyCus = this.userCustomizeCBCTbl.cus2[i]
                            const memberLABParam = this.dataLabParamsMaster.find( member => member.key === keyCus.key)
                            const memberLABParamIndex = this.dataLabParamsMaster.indexOf(memberLABParam)

                            this.dataLabParamsMaster[memberLABParamIndex].isSwitchedCUS2 = true
                            this.dataLabSelectedByUserCUS2.unshift(this.userCustomizeCBCTbl.cus2[i])
                            // this.dataLabSelectedByUserCUS2.push(this.userCustomizeCBCTbl.cus2[i])
                        }
                        // CUS3
                        for(i = 0 ; i < this.userCustomizeCBCTbl.cus3.length;i++ ){
                            const keyCus = this.userCustomizeCBCTbl.cus3[i]
                            const memberLABParam = this.dataLabParamsMaster.find( member => member.key === keyCus.key)
                            const memberLABParamIndex = this.dataLabParamsMaster.indexOf(memberLABParam)

                            this.dataLabParamsMaster[memberLABParamIndex].isSwitchedCUS3 = true
                            this.dataLabSelectedByUserCUS3.unshift(this.userCustomizeCBCTbl.cus3[i])
                            // this.dataLabSelectedByUserCUS3.push(this.userCustomizeCBCTbl.cus3[i])
                        }

                    }
                },
                immediate: true
            }
        },
        data(){
           return {
               headerCustomize : 'Customize CBC table data column No. 1',
               isSaveLoading : false,

               dataLabSelectedByUserCUS1:[
                   // {  "uuid" : "dfgsfgsdfgsdfg" , "label"  : "HGB",  "order" : 1 ,"key" : "hm_hgb" ,"group" : "HEMATO"},
                   // {  "uuid" : "sdfsdfsf" , "label"  : "PCV",  "order" : 1 ,"key" : "hm_pcv" ,"group" : "HEMATO"},
                   // {  "uuid" : "sdfsdf" , "label"  : "RBC",  "order" : 1 ,"key" : "hm_rbc" ,"group" : "HEMATO"},
                   // {  "uuid" : "sdfsdf" , "label"  : "WBC",  "order" : 1 ,"key" : "hm_wbc" ,"group" : "HEMATO"},
               ], // {  "uuid" : "dfgsfgsdfgsdfg" , "label"  : "HGB",  "order" : 1 ,"key" : "hm_hgb" ,"group" : "HEMATO"}
               dataLabSelectedByUserCUS2:[],
               dataLabSelectedByUserCUS3:[],
               dataRaw:[ {
                   "idlab": "62039974",
                   "date_req": "2019-06-01",
                   "time_req": "17:08:45",
                   "hm_hgb": "14.30",
                   "hm_pcv": "14.30",
                   "hm_rbc": "14.30",
                   "hm_wbc": "14.30",
                   "hm_my_cyte": "14.30",
                   "hm_meta": "14.30",
                   "hm_band": "14.30",
                   "hm_segs": "14.30",
                   "hm_lymph": "14.30",
                   "hm_mono": "14.30",
                   "hm_eos": "14.30",
                   "hm_unclass": "14.30",
                   "hm_nucl_rbc": "14.30",
                   "hm_retics": "14.30",
                   "hm_platelets": "14.30",
                   "hm_protein_refract": "14.30",
                   "hm_rdw": "14.30",
                   "hm_mpv": "14.30",
                   "hm_aplt": "14.30",
                   "hm_others": "14.30",
                   "bc_bun": "14.30",
                   "bc_creatinine": "14.30",
                   "bc_glucose": "14.30",
                   "bc_amylase": "14.30",
                   "bc_alt_sgpt": "14.30",
                   "bc_ast_sgot": "14.30",
                   "bc_alk_phos": "14.30",
                   "bc_cpk": "14.30",
                   "bc_bileacid_fasting": "14.30",
                   "bc_postprandial": "14.30",
                   "bc_bilirubin_total": "14.30",
                   "bc_direct": "14.30",
                   "bc_cholesterol": "14.30",
                   "bc_triglyceride": "14.30",
                   "bc_fibrinogen": "14.30",
                   "bc_protein_biuret": "14.30",
                   "bc_albumin": "14.30",
                   "bc_calcium": "14.30",
                   "bc_phosphorus": "14.30",
                   "bc_sodium": "14.30",
                   "bc_potassium": "14.30",
                   "bc_chloride": "14.30",
                   "bc_ammonia": "14.30",
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
                   // "": "" ,
               },],
               columnsCUS1: [{ field: 'idlab', label: 'LAB No' ,} ,
                   { field: 'date_req', label: 'Date' } ,
                   { field: 'time_req', label: 'Time' } ,
                   // { field: 'hm_hgb', label: 'HGB' , } ,
                   // { field: 'hm_pcv', label: 'PCV' } ,
               ],
               columnsCUS2: [{ field: 'idlab', label: 'LAB No' ,} ,
                   { field: 'date_req', label: 'Date' } ,
                   { field: 'time_req', label: 'Time' } ,
                   // { field: 'hm_hgb', label: 'HGB' , } ,
                   // { field: 'hm_pcv', label: 'PCV' } ,
               ],
               columnsCUS3: [{ field: 'idlab', label: 'LAB No' ,} ,
                   { field: 'date_req', label: 'Date' } ,
                   { field: 'time_req', label: 'Time' } ,
                   // { field: 'hm_hgb', label: 'HGB' , } ,
                   // { field: 'hm_pcv', label: 'PCV' } ,
               ],
               draggingRow: null,
               draggingRowIndex: null ,
               mainTab : 0,
               isComponentModalActive: false,
           }
        },
        methods:{
            ...mapActions({
                produceUserCustomizeCBCTblByCus : 'master_data/produceUserCustomizeCBCTblByCus',
            }),
            mainTabChange(index){
                if(index === 0 ){
                    this.headerCustomize = 'Customize CBC table data column No. 1 '
                }else if (index === 1){
                   this.headerCustomize = 'Customize CBC table data column No. 2 '
                }else if (index === 2){
                   this.headerCustomize = 'Customize CBC table data column No. 3 '
                }
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            saveData(){
                //********************
                //   save to server
                //********************
                var cus = 'CUS1' // default
                var data = this.dataLabSelectedByUserCUS1 // default
                var cusTitle = 'Customize No 1' // default

                if(this.mainTab === 0){
                    cus = 'CUS1'
                    data = this.dataLabSelectedByUserCUS1
                    cusTitle = 'Customize No 1'
                }else if(this.mainTab === 1){
                    cus = 'CUS2'
                    data = this.dataLabSelectedByUserCUS2
                    cusTitle = 'Customize No 2'
                }else if(this.mainTab === 2){
                    cus = 'CUS3'
                    data = this.dataLabSelectedByUserCUS3
                    cusTitle = 'Customize No 3'
                }


                const  dat = {
                    "cus_no" : cus,
                    "data" : data ,
                    "user_id" : this.user_id
                }


                const vm = this

                this.$buefy.dialog.confirm({
                    title: `Confirm to save ${cusTitle}  `,
                    message: `Save ${cusTitle} to server cloud ? `,
                    cancelText: 'cancel',
                    confirmText: 'OK',
                    type: 'is-success',
                    onConfirm: ( () => {
                        vm.isSaveLoading = true
                        axios.post(`${getBaseURLforBackEnd()}/api/upcuscbc`,dat,getConfigAxios())
                            .then(function () {
                                vm.isSaveLoading = false
                                vm.produceUserCustomizeCBCTblByCus(dat)
                            })
                            .finally(()=>{
                                vm.isSaveLoading = false
                                this.$buefy.toast.open({
                                    duration: 1000,
                                    message: `Successful save to cloud server`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                                })
                            })
                    })
                })

                //********************
                //   update state
                //********************



            },

            makeColumn(arr,cus){
                // sort
                var order = 0
                arr.forEach((dat)=>{
                    dat['order'] = order
                    order +=  1
                })


                cus.splice(3)
                arr.forEach( (dataLabParam) => {
                    cus.push( { field: dataLabParam.key, label: dataLabParam.label }  )
                })



            },
            //**************************
            //   CUS 1
            //**************************
            swapArrayElementsCUS1 (arr, indexA, indexB) {
                // var temp = arr[indexA];
                // arr[indexA] = arr[indexB];
                // arr[indexB] = temp;
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
            },
            dragstartCUS1 (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragoverCUS1(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleaveCUS1(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropCUS1(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElementsCUS1(this.dataLabSelectedByUserCUS1 , this.draggingRowIndex ,droppedOnRowIndex )
                this.dataLabSelectedByUserCUS1[droppedOnRowIndex]['uuid'] = genUUID(10)
                this.dataLabSelectedByUserCUS1[this.draggingRowIndex]['uuid'] = genUUID(10)

            },



            //**************************
            //   CUS 2
            //**************************
            swapArrayElementsCUS2 (arr, indexA, indexB) {
                // var temp = arr[indexA];
                // arr[indexA] = arr[indexB];
                // arr[indexB] = temp;
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
            },
            dragstartCUS2 (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragoverCUS2(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleaveCUS2(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropCUS2(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElementsCUS2(this.dataLabSelectedByUserCUS2 , this.draggingRowIndex ,droppedOnRowIndex )
                this.dataLabSelectedByUserCUS2[droppedOnRowIndex]['uuid'] = genUUID(10)
                this.dataLabSelectedByUserCUS2[this.draggingRowIndex]['uuid'] = genUUID(10)

            },

            //**************************
            //   CUS 3
            //**************************
            swapArrayElementsCUS3 (arr, indexA, indexB) {
                // var temp = arr[indexA];
                // arr[indexA] = arr[indexB];
                // arr[indexB] = temp;
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
            },
            dragstartCUS3 (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragoverCUS3(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleaveCUS3(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropCUS3(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElementsCUS3(this.dataLabSelectedByUserCUS3 , this.draggingRowIndex ,droppedOnRowIndex )
                this.dataLabSelectedByUserCUS3[droppedOnRowIndex]['uuid'] = genUUID(10)
                this.dataLabSelectedByUserCUS3[this.draggingRowIndex]['uuid'] = genUUID(10)

            }

        }
    }
</script>

<style scoped>

</style>